// sitya-doppel-pill.js — doppel_XX Cart State Manager (generic, reads data-on/off/possible)
// State 1 (base):     totalQty < 2                           fa-bolt         data-off
// State 2 (moeglich): totalQty >= 2, Kurs NICHT im Warenkorb fa-circle-plus  data-possible
// State 3 (aktiv):    totalQty >= 2, Kurs IM Warenkorb       fa-circle-check data-on
;(function () {
  'use strict';

  function stabilizeMobilePdpPill(el) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
    if (!el.closest('.product-information') || el.dataset.sityaPillStable === '1') return;

    var rect = el.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    el.style.minWidth = Math.ceil(rect.width) + 'px';
    el.style.minHeight = Math.ceil(rect.height) + 'px';
    el.dataset.sityaPillStable = '1';
  }

  function updatePills(cartItems) {
    var totalQty = cartItems.reduce(function (s, i) { return s + i.quantity; }, 0);
    var inCartIds = {};
    cartItems.forEach(function (i) { inCartIds[i.product_id] = true; });

    document.querySelectorAll('.sitya-doppel-pill').forEach(function (pill) {
      stabilizeMobilePdpPill(pill);

      var pid      = parseInt(pill.getAttribute('data-product-id'), 10);
      var on       = pill.getAttribute('data-on');
      var off      = pill.getAttribute('data-off');
      var possible = pill.getAttribute('data-possible');
      // Skip pills that have no data attributes (incomplete renders)
      if (!on || !off || !possible) return;
      var icon     = pill.querySelector('i');
      var text     = pill.querySelector('.sitya-doppel-pill__text');
      var inCart   = !!inCartIds[pid];

      if (totalQty >= 2 && inCart) {
        // State 3 – aktiv
        pill.classList.add('is-active');
        pill.classList.remove('is-possible');
        if (icon) { icon.className = 'fa-solid fa-circle-check'; }
        if (text) { text.textContent = on; }
      } else if (totalQty >= 2) {
        // State 2 – moeglich
        pill.classList.remove('is-active');
        pill.classList.add('is-possible');
        if (icon) { icon.className = 'fa-solid fa-circle-plus'; }
        if (text) { text.textContent = possible; }
      } else {
        // State 1 – base
        pill.classList.remove('is-active');
        pill.classList.remove('is-possible');
        if (icon) { icon.className = 'fa-solid fa-bolt'; }
        if (text) { text.textContent = off; }
      }
    });
  }

  function refresh() {
    fetch('/cart.json')
      .then(function (r) { return r.json(); })
      .then(function (data) { updatePills(data.items || []); })
      .catch(function () {});
  }

  document.addEventListener('cart:update',  refresh);
  document.addEventListener('cart:refresh', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
